<div class="agu-tabs" [class.agu-tabs--pill]="Variant === 'pill'" [class.agu-tabs--phone-seg]="PhoneSegmented" role="tablist">
    @for (tab of Tabs; track tab.Key) {
        <button
            #tabButton
            type="button"
            class="agu-tab"
            role="tab"
            [class.agu-tab--on]="IsActive(tab)"
            [class.agu-tab--pill]="Variant === 'pill'"
            [attr.aria-selected]="IsActive(tab)"
            [attr.aria-controls]="PanelId"
            (click)="Select(tab.Key)"
        ><!-- Bare label text, written tight against the tag exactly as the mockup
             writes it (`.vtab`, grants.html:237): the label is the tab's own
             content, and the count pill beside it is the only styled child, so a
             wrapper span here would be a class with no rule (review M-3). The
             tight formatting keeps the 9px `gap` from picking up a collapsed
             whitespace node in front of the pill. -->{{ tab.Label }}@if (HasCount(tab)) {
            <span class="agu-tab__count">{{ CountLabel(tab) }}</span>
            }</button>
    }
    <span #ink class="agu-tabs__ink" aria-hidden="true"></span>
</div>
